import {Injectable} from '@angular/core';
import {AuthService} from '../auth.service';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {AppConstants} from '../shared/app.constants';

@Injectable()
export class ManagersService {

  constructor(private auth: AuthService, private http: HttpClient, private appConstants: AppConstants) {
  }

  getAllManagers(): Observable<any> {
    const url = environment.apiBase + 'users/managers/';
    const headers = this.auth.getAuthorizationHeaders();
    return this.http.get(url, {headers}).map(res => res).catch(this.appConstants.errorHandler);
  }

}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/managers/managers.service.ts